import Nullstack from 'nullstack';
export default function IconHomeLink({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-home-link",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20.085 11.085l-8.085 -8.085l-9 9h2v7a2 2 0 0 0 2 2h4.5"
  }), "   ", Nullstack.element("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.807 1.143"
  }), "   ", Nullstack.element("circle", {
    cx: "21",
    cy: "21",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "21",
    cy: "16",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "19",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M21 16l-5 3l5 2"
  }), " ");
}